export const headerLayout = 2
export const mobileLayout = 1
export const forgotPasswordVersion = 1

$('body').addClass(`header-layout-${headerLayout}`)
$('body').addClass(`able-mobile-layout-${mobileLayout}`)
